(ns practitest.frontend.xbot
  (:require
    [reagent.dom :as rdom]
    [re-frame.core :as re-frame]
    [ajax.core :as ajax]
    [practitest.frontend.xbot.events :as events]
    [practitest.frontend.xbot.views :as views]
    ["@emotion/react" :as EmotionReact]
    ["@emotion/cache" :default createCache]
    [practitest.frontend.xbot.agents-view.views :as agents-view]
    [practitest.frontend.common.utils :as utils]))

(defonce root-el (atom nil))
(defonce status-el (atom nil))
(defonce styles-cache (atom nil))

(defn ^:dev/after-load mount-root []
  (when @root-el
    (rdom/render [:> EmotionReact/CacheProvider {:value @styles-cache}
                  [views/main-panel]]
                 @root-el))
  (when @status-el
    (rdom/render [agents-view/backend-status] @status-el)))

(defn ^:export init [options]
  (when-let [csrf-token (some-> js/document
                                (.querySelector "meta[name='csrf-token']")
                                (.getAttribute "content"))]
    (let [csrf-interceptor (ajax/to-interceptor
                            {:name    "CSRF Interceptor"
                             :request #(assoc-in % [:headers "X-CSRF-Token"] csrf-token)})]
      (swap! ajax/default-interceptors (partial cons csrf-interceptor))))

  (let [{:keys [shadow-root-id root-id config]} (js->clj options :keywordize-keys true)
        root (some-> (js/document.getElementById shadow-root-id)
                     .-shadowRoot
                     (.getElementById root-id))]
    (reset! root-el root)
    (reset! styles-cache (createCache #js {:container root
                                           :key       "shadowcache"}))
    (re-frame/dispatch-sync
      [::events/initialize-db (js->clj options :keywordize-keys true)])
    (mount-root)))

(utils/register-webcomponent! "xbot-view")
